import { Axis } from 'modules/Editor/components/SideMenuSettings/ChartSettings';
import { SideSettingDivider } from 'modules/Editor/components/SideMenuSettings/SidemenuSettingsDivider';
import { memo } from 'react';
import { WidgetType } from 'types/widget.types';

import {
  AxisFont,
  AxisLine,
  AxisLineSubSettings,
  AxisTitle,
  AxisTitleTextStyle,
  RangeSectionWithLabels,
} from '../DataTableChartCommon/ChartSettingsAxis/ChartSettingsAxis';

export const AxisSettings = memo(() => {
  return (
    <Axis>
      <AxisTitle widgetType={WidgetType.ComboChart} axisName='xAxis' />
      <AxisTitle widgetType={WidgetType.ComboChart} axisName='yAxis' />
      <AxisTitle widgetType={WidgetType.ComboChart} axisName='y2Axis' />
      <AxisFont />
      <AxisTitleTextStyle />
      <SideSettingDivider />
      <RangeSectionWithLabels axisName='yAxis' />
      <SideSettingDivider />
      <RangeSectionWithLabels axisName='y2Axis' />
      <SideSettingDivider />
      <AxisLine widgetType={WidgetType.ComboChart} axisName='xAxis' />
      <AxisLine widgetType={WidgetType.ComboChart} axisName='yAxis' />
      <AxisLine widgetType={WidgetType.ComboChart} axisName='y2Axis' />
      <AxisLineSubSettings />
    </Axis>
  );
});
AxisSettings.displayName = 'ComboChartWidgetAxisSettings';
